export default {
  myLocation: {
    stopShowingCurrentLocation: 'Klicken Sie, um die Anzeige Ihres Standorts zu beenden.',
    showCurrentLocation: 'Klicken Sie, um Ihren aktuellen Standort anzuzeigen',
    yourCurrentLocation: 'Ihr aktueller Standort',
    continuously: 'Dauerhaft',
    onlyOnce: 'Nur einmal',
    continuouslyLocation: 'Standort alle 2 Sekunden abfragen',
    onlyOnceLocation: 'Standort nur jetzt bestimmen',
    myPositionToolTip: 'Aktivieren Sie Ihren Standort, um Ihre Position anzuzeigen und Orte in der Nähe leichter zu finden'
  }
}
